import { queryKeys } from '../queryKeys'
import { auditAiRequest } from '../../util/api/audit-ai-api'
import { createDashboardTableHook } from './dashboardHookUtils'
import type { DashboardMeasureTableResponse } from '@counsel-project/counsel-audit-ai-api'

type UseDashboardTableMeasuresOptions = {
  page?: number
  limit?: number
}

export const useDashboardTableMeasures = (options: UseDashboardTableMeasuresOptions = {}) => {
  return useDashboardTableMeasuresFactory(options)
}

const useDashboardTableMeasuresFactory = createDashboardTableHook<
  DashboardMeasureTableResponse,
  UseDashboardTableMeasuresOptions
>({
  buildQueryKey: queryKeys.dashboardTableMeasures,
  request: auditAiRequest.dashboard.tableMeasures,
  paginationMode: 'url',
  defaultRowsPerPage: 10,
  getOptionPage: (hookOptions) => hookOptions.page,
  getOptionLimit: (hookOptions) => hookOptions.limit,
  enableSorting: false,
})
